import { getEntries } from '@/fleet-configuration/data-fleet/entries/entries-selectors'
import { DEVICE_CALIBRATION_PRE_EXPIRATION_WARNING_DAYS } from '@/fleet-configuration/data-fleet/devices-calibrations/devices-calibrations-constants'
import intersection from 'lodash-es/intersection.js'
import { NOT_CALIBRABLE_DEVICE_TYPES } from '@/fleet-configuration/pages/fleet-overview/fleet-overview-constants'
import { getDeviceById } from '@/fleet-configuration/data-fleet/devices/devices-selectors'
import { getCalibrationWarningDays } from '@/fleet-configuration/data-fleet/calibration/calibration-selectors'

export const getDeviceCalibrations = state => getEntries(state, 'entries.devicesCalibrations')

export const getDeviceCalibrationsByDeviceId = (state, deviceId) => state.entries.devicesCalibrations.byId[deviceId]

// Pure helper. `warningDays` is the per-tenant "expire soon" threshold (defaulting to the legacy
// hardcoded value when the setting hasn't been hydrated yet).
//
// Returns three booleans:
//   - isExpired:      today is past calibrationExpires
//   - isExpiringSoon: not expired, but today + warningDays would be past calibrationExpires
//   - isExpiring:     isExpired || isExpiringSoon — kept for callers that don't need to
//                     distinguish the two (e.g. notification counts)
export const getIfCalibrationIsLoadedOrExpiring = (
  calibration,
  warningDays = DEVICE_CALIBRATION_PRE_EXPIRATION_WARNING_DAYS,
) => {
  let isExpired = false
  let isExpiringSoon = false
  if (calibration?.calibrationDate) {
    const calibrationExpires = new Date(calibration.calibrationDate)
    calibrationExpires.setDate(calibrationExpires.getDate() + calibration.calibrationIntervalDays)
    const today = new Date()
    const warningThreshold = new Date()
    warningThreshold.setDate(warningThreshold.getDate() + warningDays)
    isExpired = today.getTime() > calibrationExpires.getTime()
    isExpiringSoon = !isExpired && warningThreshold.getTime() > calibrationExpires.getTime()
  }
  return {
    isExpired,
    isExpiringSoon,
    isExpiring: isExpired || isExpiringSoon,
    isLoaded: calibration && !calibration.hasRequestError && !calibration.isLoading,
  }
}

export const getExtendedDeviceCalibrationByDeviceId = (state, deviceId) => {
  const deviceCalibrations = getDeviceCalibrationsByDeviceId(state, deviceId)
  const device = getDeviceById(state, deviceId)
  const isLoadedOrExpiring = getIfCalibrationIsLoadedOrExpiring(deviceCalibrations, getCalibrationWarningDays(state))
  // Ignore KGATE_DEVICE_TYPE and FORCE_PLATE_SYNC_BOX types as they are not calibrable
  const isDeviceCalibrable = device && !intersection(NOT_CALIBRABLE_DEVICE_TYPES, device.types).length

  return {
    ...deviceCalibrations,
    ...isLoadedOrExpiring,
    isCalibrable: isDeviceCalibrable,
  }
}
